import { Component, OnInit, ViewEncapsulation, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CommonService } from '../services/common.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-popup',
    templateUrl: './idlepopup.component.html',
    styleUrls: ['./idlepopup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, NgClass, MatButton, MatDialogClose]
})
export class IdlePopupComponent implements OnInit {
public dialogContent: any;
  @Output() confirmClick: EventEmitter<any> = new EventEmitter();
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public dialogRef: MatDialogRef<IdlePopupComponent>,
    public commonService: CommonService
    ) {
    this.dialogContent = data;
  }

  close() {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

  confirm(event: any) {
    this.dialogContent.confirmClick.emit(event);
  }

}
